module.exports = __webpack_public_path__ + "static/media/15_Maf_NuestroEquipo_MarioAvila.a7b71c00-01.11283402.png";